import React, {Component} from 'react';
import {Add, DataUsage} from '@mui/icons-material';
import {Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, TextField} from '@mui/material';
import ReactFileReader from 'react-file-reader';
import {connect} from 'react-redux';
import * as XLSX from 'xlsx';

import {getSMSDetails, sendCustomizeSms} from '../../actions/sms';
import {getTemplate} from '../../actions/template';
import Select from '../../components/Select';
import Table from '../../components/Table';
import TemplateList from '../../components/TemplateList';
import TemplateForm from '../Template/TemplateForm';
import {GAEventTracker} from '../../lib/googleAnalytics';
import {getDynamicPlaceholderSlots, isNotValidPromoTime, replaceDynamicPlaceholderTokens} from '../../lib/utils';
import {SEND_SMS_MAINTENANCE, SEND_SMS_MAINTENANCE_MSG, SEND_SMS_MAINTENANCE_SNACK_PROPS} from '../../lib/constant';
import Heading from '../NewDashboard/Heading';
import SMSBalanceMobile from '../Sms/smsBalanceM';
import SmsFlashOptionButton from "../Sms/smsFlashOptionButton";


class Sms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFlashEnabled: false,
      openSnackBar: false,
      snackBarMaintenance: false,
      smsText: '',
      snackBarMsg: '',
      btnDisabled: false,
      readFile: false,
      smsDetails: props.smsDetails && props.smsDetails.success ? props.smsDetails.data : {},
      senderId: null,
      showAddTemplate: false,
      smsType: null,
      excelData: null,
      cols: [],
      mobCol: "Choose",
      msgCol: "Choose",
      cstmMsg: [],
      showPreviewMsg: false,
      selectedTemplate: '',
      dynamicFieldInMsg: 0,
      dynamicMap: {}
    };
    this.smsSent = false;
    this.receivedSMSDetails = false;
    this.smsLengthRange = {
      normal: {
        single: 160,
        multi: 153
      },
      unicode: {
        single: 70,
        multi: 67
      }
    };
    this.smsLength = 0;
    this.senderIds = null;
    this.selectedTemplateId = null;
    this.isSmsFlashEnabledFn = this.isSmsFlashEnabledFn.bind(this);
  }
  componentDidMount() {
    window._epadhaiGTM.push({event: 'customizeSmsSection'});
    this.props.getSMSDetails();
    this.props.getTemplate();
  }
  componentWillReceiveProps(nextProps) {
    const {
      sendCustomSmsResponse, smsDetails
    } = nextProps;
    if (smsDetails) {
      if (smsDetails.success) {
        const smsDet = smsDetails.data;
        if (!this.receivedSMSDetails) {
          this.receivedSMSDetails = true;
          this.senderIds = smsDet.senderIds;
          this.senderIdObjects = smsDet.senderIdObjects || [];
          const filteredSmsTypes = this.getSmsTypesForSenderId(smsDet.defaultSenderId, smsDet);
          this.setState({
            smsDetails: smsDet, senderId: smsDet.defaultSenderId, smsType: filteredSmsTypes[0] || smsDet.defaultSmsType
          });
        } else if (this.state.smsDetails !== smsDet) {
          this.setState({smsDetails: smsDet});
        }
      } else if (!this.receivedSMSDetails && smsDetails.err) {
        this.receivedSMSDetails = true;
        alert(smsDetails.err.msg);
        window.location.reload();
      } else if (!this.receivedSMSDetails) {
        this.receivedSMSDetails = true;
        alert('Something went wrong!');
        window.location.reload();
      }
    }
    if (this.smsSent && sendCustomSmsResponse) {
      this.smsSent = false;
      let snackBarMsg = 'SMS Submitted Successfully! View SMS Reports for More Details';
      if (sendCustomSmsResponse.err) {
        snackBarMsg = sendCustomSmsResponse.err.msg;
        GAEventTracker({category : 'Customize-SMS', action : 'Send SMS Error', label : snackBarMsg});
        this.setState({btnDisabled: false, snackBarMsg, openSnackBar: true, showPreviewMsg: false});
      } else if (sendCustomSmsResponse.success) {
        GAEventTracker({category : 'Customize-SMS', action : 'Send SMS', value : this.processCustomMsg.length});
        snackBarMsg = sendCustomSmsResponse.data.msg;
        this.props.getSMSDetails();
        this.setState({
          btnDisabled: false, snackBarMsg, openSnackBar: true, smsText: '', showPreviewMsg: false, isFlashEnabled: false, selectedTemplate: '',
          dynamicFieldInMsg: 0, dynamicMap: {}
        });
      } else {
        snackBarMsg = 'Something went wrong, Please try again!';
        GAEventTracker({category : 'Customize-SMS', action : 'Send SMS Error', label : snackBarMsg});
        this.setState({btnDisabled: false, snackBarMsg, openSnackBar: true, showPreviewMsg: false});
      }
    }
  }
  isSmsFlashEnabledFn(isFlashEnabled){
    this.setState({isFlashEnabled})

  }
  handleSnackBarClose = () => this.setState({openSnackBar: false, snackBarMaintenance: false});
  sendParams = () => {
    const {smsType, senderId, isFlashEnabled, cstmMsg} = this.state;
    if (isFlashEnabled) {
      GAEventTracker({category : 'Flash-SMS', action : 'Send', label: 'Customize-SMS'});
    }
    const customMessages = {};
    cstmMsg.forEach(msg => {
      customMessages[String(msg.mobile)] = msg.text;
    });
    return {
      senderId,
      smsType,
      customMessages,
      isFlashEnabled,
      templateId: this.selectedTemplateId
    };
  }
  previewSMS = () => {
    const {smsText, excelData, mobCol, dynamicMap} = this.state;
    const placeholderSlots = getDynamicPlaceholderSlots(smsText);
    if (Object.keys(dynamicMap).length !== placeholderSlots.length) {
      alert('Please select columns for all dynamic field!');
      return;
    }
    let totalSMSCount = 0
    const numRegex = [new RegExp('^[3-9][0-9]{9}$'), new RegExp('^91[3-9][0-9]{9}$'), new RegExp('^/+91[3-9][0-9]{9}$'), new RegExp('^/+91-[3-9][0-9]{9}$')]
    const filteredData = []
    excelData.forEach(el => {
      const num = el[mobCol]
      let i=0;
      for (; i<numRegex.length; i++) {
        if (numRegex[i].test(num)) {
          break
        }
      }
      if (i < numRegex.length) {
        let newNum = Number(num)
        if (i > 0) {
          newNum = Number(num.toString().slice(i+1))
        }
        filteredData.push({...el, [mobCol]: newNum})
      }
    })
    let cstmMsg = filteredData.map(data => {
      const replacements = placeholderSlots.map((slot, index) => data[dynamicMap[index]]);
      const text = replaceDynamicPlaceholderTokens(smsText, replacements);
      totalSMSCount += this.calculateSmsText(text)
      return {text, mobile: data[mobCol]}
    })
    this.processCustomMsg = cstmMsg
    this.totalSMSCount = totalSMSCount
    this.setState({showPreviewMsg: true, cstmMsg})
  }
  handleSend = () => {
    const {smsType, smsDetails} = this.state;
    if (SEND_SMS_MAINTENANCE) {
      this.setState({snackBarMsg: SEND_SMS_MAINTENANCE_MSG, openSnackBar: true, snackBarMaintenance: true});
      return;
    }
    // DLT rule: Promotional SMS can only be sent 9AM-9PM IST
    if ((smsType === 'Promotional' || smsType === 'PROMO') && isNotValidPromoTime()) {
      alert('Promotional SMS can only be sent between 9:00 AM to 9:00 PM IST');
      return;
    }
    if (smsDetails.smsCount[smsType] - smsDetails.scheduledSmsCount[smsType] < this.totalSMSCount) {
      alert("Sorry, You can't send SMS as you have already Scheduled SMS which will not be sent due to lack of sms availablity!");
      return;
    }
    if (this.processCustomMsg.length > 40000) {
      alert('Sorry, We can send only 40,000 sms at a time. Please try sending less than 40,000 sms only.');
      return;
    }
    const params = this.sendParams();
    if (params) {
      this.smsSent = true;
      this.setState({btnDisabled: true});
      GAEventTracker({category: 'Customize-SMS', action: 'Send SMS Initiated', value: this.processCustomMsg.length});
      this.props.sendCustomizeSms(params);
    }
  };
  handleSmsTextChange = smsText => {
    const dynamicFieldInMsg = getDynamicPlaceholderSlots(smsText).length;
    this.setState({ smsText, dynamicFieldInMsg });
  }

  calculateSmsText = (val) => {
    let smsLength = 0,
      text = val,
      isUnicode = false
    for (let charPos = 0; charPos < text.length; charPos++) {
      switch (text[charPos]) {
      case '[':
      case ']':
      case '\\':
      case '^':
      case '{':
      case '}':
      case '|':
      case '€':
        smsLength += 2;
        break;
      default:
        smsLength += 1;
      }
      if ((!isUnicode && text.charCodeAt(charPos) > 127 && text[charPos] !== '€') || text[charPos] === '\t') {
        isUnicode = true;
      }
    }
    const lenCal = isUnicode ? this.smsLengthRange.unicode : this.smsLengthRange.normal;
    const len = smsLength;
    return len <= lenCal.single ? 1 : (parseInt(len / lenCal.multi) + (len % lenCal.multi == 0 ? 0 : 1));
  }
  handleFiles = files => {
    const reader = new FileReader();
    const _this = this;
    this.setState({readFile: true});
    reader.onload = function (e) {
      const bstr = reader.result;
      const wb = XLSX.read(bstr, {type: 'binary'});
      const ws = wb.Sheets[wb.SheetNames[0]];
      let excelData = XLSX.utils.sheet_to_json(ws)
      _this.setState({excelData, readFile: false, cols: Object.keys(excelData[0]), dynamicMap: {}, mobCol: 'Choose'});
      GAEventTracker({category: 'Customize-SMS', action: 'Excel Uploaded', value: excelData.length});
    };
    reader.readAsBinaryString(files[0]);
  }
  countContacts = () => {
    return 1
  }
  // Get allowed SMS types based on sender ID's header type and available wallet balances
  getSmsTypesForSenderId = (senderId, smsDet) => {
    const senderObj = (this.senderIdObjects || []).find(s => s.id === senderId);
    const headerType = senderObj?.headerType || '';
    const allTypes = smsDet?.smsType || [];
    const smsCount = smsDet?.smsCount || {};

    // Alphanumeric → Transactional, OTP; Numeric → Promotional
    let allowedTypes;
    if (headerType === 'HEADER_TYPE_NUMERIC' || headerType === 'numeric') {
      allowedTypes = ['Promotional'];
    } else if (headerType === 'HEADER_TYPE_ALPHANUMERIC' || headerType === 'alphanumeric') {
      allowedTypes = ['Transactional', 'OTP', 'Promotional'];
    } else {
      allowedTypes = allTypes;
    }
    // Only show types that have balance > 0
    return allowedTypes.filter(t => allTypes.includes(t) && (smsCount[t] || 0) > 0);
  }
  // Get allowed sender IDs based on selected SMS type
  getSenderIdsForSmsType = (smsType) => {
    const allSenderIds = this.senderIdObjects || [];
    if (smsType === 'Transactional' || smsType === 'OTP') {
      return allSenderIds.filter(s =>
        s.headerType === 'HEADER_TYPE_ALPHANUMERIC' || s.headerType === 'alphanumeric'
      ).map(s => s.id);
    }
    if (smsType === 'Promotional') {
      // Both alphanumeric and numeric can send promotional
      return allSenderIds.map(s => s.id);
    }
    return allSenderIds.map(s => s.id);
  }
  handleToggle = (e) => {
    const smsType = e.target.value;
    const filteredSenderIds = this.getSenderIdsForSmsType(smsType);
    const senderId = filteredSenderIds.includes(this.state.senderId) ? this.state.senderId : (filteredSenderIds[0] || '');
    this.setState({smsType, senderId, isFlashEnabled: false, smsText: '', selectedTemplate: '', dynamicFieldInMsg: 0, dynamicMap: {}});
  }
  openUploadExcel = () => {
    GAEventTracker({category: 'Customize-SMS', action: 'Upload Excel'});
  }
  handleSenderIdChange = (e) => {
    const senderId = e.target.value;
    const filteredSmsTypes = this.getSmsTypesForSenderId(senderId, this.state.smsDetails);
    this.setState({senderId, smsType: filteredSmsTypes[0] || '', smsText: '', selectedTemplate: '', dynamicFieldInMsg: 0, dynamicMap: {}});
  }
  handleColChange = (type) => (e) => this.setState({[type]: e.target.value})
  getNumberMessageCol = () => {
    const {excelData, mobCol, cols} = this.state;
    if (!excelData || excelData.length === 0) {
      return null;
    }
    return (
      <div style={{marginTop: 20}}>
        <Select
          id="mobCol"
          value={mobCol}
          onChange={this.handleColChange('mobCol')}
          sx={{width: 200}}
          options={cols}
          label="Mobile Number Column"
          required
        />
      </div>
    )
  }
  customMsgDropdown = (index) => {
    const {cols} = this.state;
    const colItems = []
    if (cols.length) {
      colItems.push({value: 0, name: 'Choose'})
      for(let col of cols){
        colItems.push({value: col, name: <div dangerouslySetInnerHTML={{__html: col}}></div>})
      }
    }
    return colItems;
  }
  addCustomMsg = (slotIndex) => (event) =>{
    let {dynamicMap} = this.state;
    const value = event.target.value;
    if (value == 0) {
      delete dynamicMap[slotIndex]
    } else {
      dynamicMap[slotIndex] = value
    }
    this.setState({dynamicMap})
    GAEventTracker({category : 'Customize-SMS', action : 'Signature Selected'});
  }
  closePreviewSMS = () => this.setState({showPreviewMsg: false})

  // All templates registered for the selected header (sender ID). No category
  // filtering — the backend derives the DLT category from the header type.
  getTemplateList = () => {
    const {templateRes} = this.props;
    const {senderId} = this.state;
    if (templateRes && templateRes.success && templateRes.data && templateRes.data?.template.length) {
      return templateRes.data?.template.filter(data => data.senderId === senderId);
    }
    return [];
  }

  handleSelectTemplate = (e) => {
    const selectedItem = this.props.templateRes.data?.template.find(data => data.id === e.target.value)
    this.selectedTemplateId = selectedItem.dltTemplateId || selectedItem.id;
    const placeholderSlots = getDynamicPlaceholderSlots(selectedItem.text);
    this.setState({
      selectedTemplate: e.target.value, smsText: selectedItem.text, dynamicMap: {}, dynamicFieldInMsg: placeholderSlots.length
    }, () => this.calculateSmsText(selectedItem.text));
  }

  getSMSPreview = () => {
    const {smsText, dynamicMap} = this.state;
    const placeholderSlots = getDynamicPlaceholderSlots(smsText);
    const replacements = placeholderSlots.map((slot, index) => dynamicMap[index]);
    return replaceDynamicPlaceholderTokens(smsText, replacements);
  }

  render() {
    const isMobile = window.isMobile();
    const {
      smsDetails, readFile, smsText, btnDisabled, openSnackBar, snackBarMsg, senderId, smsType, cols, showPreviewMsg, cstmMsg, mobCol, selectedTemplate,
      dynamicFieldInMsg, dynamicMap
    } = this.state;
    const smsDetailsLen = Object.keys(smsDetails).length;
    const templateList = this.getTemplateList();
    return (
      <div className='sms-parent-container' style={isMobile ? {padding: 8} : {}} id='sms-ui'>
        <div>
          {
            smsDetailsLen ?
              <>
                {isMobile && <SMSBalanceMobile smsDetails={ smsDetails } />}
                <Heading>Select Header and SMS Type</Heading>
                <div className='sms-small-container-new'>
                  {(() => { const filteredSenderIds = this.getSenderIdsForSmsType(smsType); return filteredSenderIds.length > 0 && (
                <Select
                  id="senderId"
                  value={senderId}
                  onChange={this.handleSenderIdChange}
                  label="Select Header"
                  sx={{minWidth: 170}}
                  options={filteredSenderIds}
                  required
                />
                  ); })()}
                  {(() => { const filteredTypes = this.getSmsTypesForSenderId(senderId, smsDetails); return filteredTypes.length > 0 && (
                <Select
                  id="smsType"
                  value={smsType}
                  onChange={this.handleToggle}
                  label="Select SMS Type"
                  sx={{minWidth: 170, marginLeft: 2}}
                  options={filteredTypes.map(el => ({name: el, value: el}))}
                  required
                />
                  ); })()}
                </div>
                <Heading>Choose Template</Heading>
                <div className='sms-small-container-new'>
                  <div>
                    {templateList.length > 0 ? 
                      <TemplateList selectedTemplate={selectedTemplate} templateList={templateList} onChange={this.handleSelectTemplate} />
                      :
                      <div style={{marginTop: 10}}>
                        {/* No templates for this header: the same Add Template form as the Templates page. */}
                        <Button
                          variant="contained"
                          size="small"
                          startIcon={ <Add /> }
                          onClick={ () => this.setState({showAddTemplate: true}) }
                          sx={{textTransform: 'none'}}
                        >
                          Add Template
                        </Button>
                      </div>
                    }
                    <div style={{paddingTop: 8, fontSize: 14, color: 'rgba(0, 0, 0, 0.6)'}}>
                      Upload Excel File and choose columns for Mobile Number and Message from your uploaded file to send Customized SMS.
                    </div>
                    <div>
                      <ReactFileReader
                        handleFiles={ this.handleFiles }
                        fileTypes={ '.csv,.xlsx,.xls' }
                        elementId='fileUpload'
                      >
                        <Button variant="outlined" onClick={this.openUploadExcel}>Upload Excel (.xlsx,.xls,.csv)</Button>
                      </ReactFileReader>
                    </div>
                    {this.getNumberMessageCol()}
                    <div style={{marginTop: 16}}>
                      <div style={{display:'flex', gap: 8}}>
                        {
                          cols.length > 0 && dynamicFieldInMsg > 0 && 
                            getDynamicPlaceholderSlots(smsText).map((slot, index) =>
                              (
                                <Select
                                  id={`dynamicFieldInMsg-${slot.name}-${index}`}
                                  key={`${slot.name}-${index}`}
                                  value={dynamicMap[index] || 0}
                                  onChange={this.addCustomMsg(index)}
                                  sx={{width: 200}}
                                  options={this.customMsgDropdown(index)}
                                  label={`Select ${slot.displayName} Column`}
                                  required
                                />
                              ))
                        }
                      </div>
                      <TextField
                        id="customSms"
                        label="SMS Text"
                        multiline
                        rows={4}
                        value={ smsText }
                        onChange={ (e) => this.handleSmsTextChange(e.target.value) }
                        inputRef={ (input) => this.smsInput = input }
                        fullWidth
                        sx={{mt: 2}}
                        disabled
                        required
                        variant="standard"
                        inputProps={{maxLength: 918}}
                      />
                      <div style={{display: 'flex', marginTop: 8, alignItems: 'center', ...(isMobile ? {flexWrap: 'wrap'} : {})}}>
                        <div>
                          {smsDetails.smsType.length === 2 &&
                          <p style={ {fontSize: 14, color: '#d32f2f', marginTop: 5} }>Note : You have selected {smsType} type!</p>
                          }
                        </div>
                        <div style={{marginLeft: 'auto'}}>
                          {smsType !== 'OTP' && <SmsFlashOptionButton
                            isSmsFlashEnabledFn={ this.isSmsFlashEnabledFn }
                            pageType='Customize-SMS'
                          />
                          }
                          <Button variant="contained" disabled={ !smsText || mobCol === 'Choose' } onClick={this.previewSMS}>Preview</Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
              :
              <Dialog open>
                <DialogContent sx={{width: 100}}>
                  <div>
                    <CircularProgress />
                  </div>
                </DialogContent>
              </Dialog>
          }
        </div>
        {readFile &&
          <Dialog open>
            <DialogContent sx={{width: 325}}>
              <div>
                <p style={ {width: 200, margin: '0 auto', textAlign: 'center', marginBottom: 10} }>
                  <DataUsage sx={{color: '#1976d2', fontSize: 50}} onClick={e => e.stopPropagation()} />
                </p>
                <p>Please wait while we process your file!</p>
              </div>
            </DialogContent>
          </Dialog>
        }
        {showPreviewMsg &&
          <Dialog
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            open
            onClose={this.closePreviewSMS}
          >
            <DialogTitle id="alert-dialog-title">
              Preview Submission
            </DialogTitle>
            <DialogContent>
              <div>
                <div style={{marginBottom: 16}}>
                  <Table
                    column={[
                      {name: 'Mobile', value: 'mobile', style:{width:'20%'}},
                      {name: 'Message', value: 'text', style: {width:'70%', whiteSpace: 'break-spaces'}},
                      {name: 'Length', value: 'length', style: {width:'10%'}}
                    ]}
                    data={cstmMsg.map(el => ({...el, length: el.text.length}))}
                  />
                </div>
                <p>Total Contacts: {this.processCustomMsg.length}</p>
                <p>Total SMS: {this.totalSMSCount}</p>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.closePreviewSMS}>Close</Button>
              <Button disabled={btnDisabled} onClick={this.handleSend} variant='contained'>Send Now</Button>
            </DialogActions>
          </Dialog>
        }
        {
          btnDisabled &&
          <Dialog open>
            <DialogContent sx={{width: 500}}>
              <div>
                <CircularProgress />
                <br />
                Please wait while we submit your message!
              </div>
            </DialogContent>
          </Dialog>
        }
        {openSnackBar &&
          <Snackbar
            open
            message={ snackBarMsg }
            autoHideDuration={ this.state.snackBarMaintenance ? 8000 : 4000 }
            onClose={this.handleSnackBarClose}
            ContentProps={ this.state.snackBarMaintenance ? SEND_SMS_MAINTENANCE_SNACK_PROPS : undefined }
          />
        }
        {this.state.showAddTemplate &&
          <TemplateForm
            defaultSenderId={ this.state.senderId }
            closeHandler={ () => this.setState({showAddTemplate: false}) }
            handlePostTemplate={ () => {
              // The template list reads templateRes, so a refetch shows the new one.
              this.setState({showAddTemplate: false});
              this.props.getTemplate();
            } }
          />
        }
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    sendCustomSmsResponse: state.smsResponse.sendCustomSmsResponse,
    smsDetails: state.smsResponse.smsDetailsResponse,
    templateRes: state.template.templateList
  };
}
export default connect(mapStateToProps, {sendCustomizeSms, getSMSDetails, getTemplate})(Sms);
